export const PageHead = ({ title, sub, children, testId }) => (
  <div className="flex flex-wrap items-end justify-between gap-3" data-testid={testId}>
    <div className="min-w-0"><h1 className="text-3xl font-bold text-navy">{title}</h1>{sub && <p className="mt-1 text-sm text-slate-500">{sub}</p>}</div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, sub, action, children, testId, className = "" }) => (
  <section className={`min-w-0 rounded-2xl bg-white p-4 shadow-sm sm:p-5 ${className}`} data-testid={testId}>
    {(title || action) && (
      <div className="mb-3 flex flex-wrap items-start justify-between gap-2">
        <div><h2 className="text-base font-semibold text-navy md:text-lg">{title}</h2>{sub && <p className="text-xs text-slate-500">{sub}</p>}</div>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const btn = "inline-flex h-11 items-center justify-center gap-2 rounded-full px-5 text-sm font-semibold transition-transform duration-150 active:scale-95 disabled:opacity-50";
export const btnPrimary = `${btn} bg-navy text-white hover:bg-navy/90`;
export const btnGreen = `${btn} bg-brand text-white hover:bg-brand/90`;
export const btnGhost = `${btn} bg-white text-navy shadow-sm hover:bg-slate-50`;
export const input = "h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-navy outline-none focus:border-brand";
export const chip = (on) => `h-10 rounded-full px-4 text-sm font-medium transition-colors ${on ? "bg-navy text-white" : "bg-white text-navy shadow-sm"}`;

export const Field = ({ label, children }) => (
  <label className="block text-xs font-medium text-slate-500">{label}<div className="mt-1">{children}</div></label>
);

export const Light = ({ status, testId }) => {
  const c = { green: "bg-brand", amber: "bg-amber-400", red: "bg-rose-500" }[status] || "bg-slate-200";
  return <span data-testid={testId} className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${c}`} />;
};
